import "core-js";

import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { ConfigProvider } from "antd";
import SwiperCore, { EffectFade, Navigation, Pagination } from "swiper";
import fa_IR from "antd/lib/locale-provider/fa_IR";
import Router from "./router";
import store from "./scripts/store";

import "leaflet/dist/leaflet.css";
import "./styles/index.less";

SwiperCore.use([EffectFade, Navigation, Pagination]);

import CssPrefix from "components/css-prefix";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <ConfigProvider direction="rtl" locale={fa_IR}>
    <Provider store={store}>
      <CssPrefix />
      <Router />
    </Provider>
  </ConfigProvider>
);
